import {
  latestTote,
  toteTrackerTotes,
  totes,
  markToteDelivered,
  scheduleAutoPickup,
  toteProduct,
  SubmitSwapQuestion,
  scheduleSelfDelivery,
  unreturnToteParts,
  checkExpressStatus
} from 'src/app/queries/queries'

const queryToteStateTips = (success, error) => {
  return {
    type: 'API:TOTES:STATE_TIPS',
    API: true,
    method: 'POST',
    url: '/api/query',
    data: { query: totes.toteStateTipsQuery },
    success,
    error
  }
}

const scheduleReturnAutoPickup = (input, success, error) => {
  return {
    type: 'API:TOTES:SCHEDULE:RETURN:AUTO:PICKUP',
    API: true,
    method: 'POST',
    url: '/api/query',
    data: {
      query: scheduleAutoPickup,
      variables: {
        input
      }
    },
    success: success,
    error: error
  }
}

const scheduleReturnSelfDelivery = (input, success, error) => {
  return {
    type: 'API:TOTES:SCHEDULE:RETURN:SELF:DELIVERY',
    API: true,
    method: 'POST',
    url: '/api/query',
    data: {
      query: scheduleSelfDelivery,
      variables: {
        input
      }
    },
    success: success,
    error: error
  }
}

const fetchLatest = () => {
  return {
    type: 'API:TOTES:FETCH_LATEST',
    API: true,
    method: 'POST',
    url: '/api/query',
    data: {
      query: latestTote
    }
  }
}

const markToteAsDelivered = (toteId, success) => {
  return {
    type: 'API:TOTES:MARK_TOTE_AS_DELIVERED',
    API: true,
    method: 'POST',
    url: '/api/query',
    data: {
      query: markToteDelivered,
      variables: {
        input: {
          tote_id: toteId
        }
      }
    },
    success
  }
}

const fetchLatestRentalTote = (success = () => {}, error = () => {}) => {
  return {
    type: 'API:TOTES:FETCH_LATEST_RENTAL_TOTE',
    API: true,
    method: 'POST',
    url: '/api/query',
    success,
    error,
    data: {
      query: toteTrackerTotes
    }
  }
}

const fetchLatestRentalAndPurchaseTote = (success = () => {}) => {
  return {
    type: 'API:TOTES:FETCH_LATEST_RENTAL_PURCHASE',
    API: true,
    method: 'POST',
    url: '/api/query',
    success,
    data: {
      query: totes.currentTotesQuery,
      variables: { filter: 'current' }
    }
  }
}

const fetchPastTotes = (page, success) => {
  return (dispatch, getState) => {
    const state = getState()
    const action = {
      type: 'API:TOTES:FETCH_PAST_TOTES',
      API: true,
      method: 'POST',
      url: '/api/query',
      page: page,
      success,
      data: {
        query: totes.historyTotesQuery,
        variables: {
          page: page || state.totes.past_totes_page,
          filter: 'history'
        }
      }
    }

    dispatch(action)
  }
}

const fetchDeliverTotes = ({ page, filter, per_page = 5 }, success) => {
  return dispatch => {
    const action = {
      type: 'API:TOTES:FETCH_DELIVERED_TOTES',
      API: true,
      method: 'POST',
      url: '/api/query',
      success,
      data: {
        query: totes.deliveredTotesQuery,
        variables: { page, filter, per_page }
      }
    }

    dispatch(action)
  }
}

const fetchPastDeliverTotes = ({ page, filter, per_page = 5 }, success) => {
  return dispatch => {
    const action = {
      type: 'API:TOTES:FETCH_PAST_DELIVERED_TOTES',
      API: true,
      method: 'POST',
      url: '/api/query',
      success,
      data: {
        query: totes.deliveredTotesQuery,
        variables: { page, filter, per_page }
      }
    }

    dispatch(action)
  }
}

const getToteProduct = id => ({
  type: 'API:FETCH:TOTE:PRODUCT',
  API: true,
  method: 'POST',
  url: '/api/query',
  data: { query: toteProduct, variables: { id } }
})

const submitSwapQuestion = (input, success) => ({
  type: 'API:SUBMIT:SWAP:QUESTION',
  API: true,
  method: 'POST',
  url: '/api/query',
  data: {
    query: SubmitSwapQuestion,
    variables: {
      input
    }
  },
  success
})

const resetToteProduct = () => ({
  type: 'RESET:TOTE:PRODUCT'
})

const fetchToteCount = () => ({
  type: 'API:FETCH:TOTE:COUNT',
  API: true,
  method: 'POST',
  url: '/api/query',
  data: {
    query: totes.totesCountQuery
  }
})

const queryUnreturnToteParts = (input, success, error) => {
  return {
    type: 'API:FETCH:UNRETURN:TOTE:PARTS',
    API: true,
    method: 'POST',
    url: '/api/query',
    data: {
      query: unreturnToteParts,
      variables: input
    },
    success,
    error
  }
}

const queryExpressStatus = (input, success, error) => {
  return {
    type: 'API:FETCH:EXRPESS:STATUS',
    API: true,
    method: 'POST',
    url: '/api/query',
    data: {
      query: checkExpressStatus,
      variables: input
    },
    success,
    error
  }
}

export default {
  fetchLatest,
  fetchLatestRentalAndPurchaseTote,
  fetchPastTotes,
  markToteAsDelivered,
  scheduleReturnAutoPickup,
  getToteProduct,
  resetToteProduct,
  submitSwapQuestion,
  scheduleReturnSelfDelivery,
  fetchToteCount,
  queryToteStateTips,
  fetchLatestRentalTote,
  fetchDeliverTotes,
  fetchPastDeliverTotes,
  queryUnreturnToteParts,
  queryExpressStatus
}
